import { Box, CircularProgress, Typography, useTheme } from "@mui/material";

function Loader({ message }: { message: string }) {
  const { palette } = useTheme();
  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      height="100dvh"
      justifyContent="center"
      alignItems="center"
      gap={2}
      bgcolor={palette.background.level1}
      pb={20}
    >
      <Typography variant="prose-2xl-medium" color="text.primary" textAlign="center">
        {message}
      </Typography>
      <>
        <svg width={44} height={44}>
          <defs>
            <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor={palette.zones["4dp"].ftp.main} />
              <stop offset="31.5%" stopColor={palette.zones["4dp"].map.main} />
              <stop offset="74%" stopColor={palette.zones["4dp"].ac.main} />
              <stop offset="100%" stopColor={palette.zones["4dp"].nm.main} />
            </linearGradient>
          </defs>
        </svg>
        <CircularProgress sx={{ "svg circle": { stroke: "url(#my_gradient)" } }} />
      </>
    </Box>
  );
}

export default Loader;
